import script from "./Download.vue?vue&type=script&setup=true&lang=js"
export * from "./Download.vue?vue&type=script&setup=true&lang=js"

import "./Download.vue?vue&type=style&index=0&id=9cff41fe&lang=scss"

const __exports__ = script;

export default __exports__